const skillCategories = [
  {
    id: "cybersecurity-soc",
    title: "Cybersecurity & SOC",
    icon: "🛡️",
    priority: "Primary Focus",
    description:
      "Defensive security, monitoring, investigation, and incident-response capabilities.",
    skills: [
      {
        name: "Security Monitoring",
        level: "operational",
        description: "Monitoring Windows and Linux security activity"
      },
      {
        name: "Log Analysis",
        level: "operational",
        description: "Reviewing and correlating system and security events"
      },
      {
        name: "Alert Triage",
        level: "hands-on",
        description: "Assessing alerts and identifying suspicious activity"
      },
      {
        name: "Incident Investigation",
        level: "hands-on",
        description: "Investigating authentication, endpoint, and phishing events"
      },
      {
        name: "MITRE ATT&CK",
        level: "hands-on",
        description: "Mapping observed behaviour to attack techniques"
      }
    ]
  },
  {
    id: "siem-endpoint-monitoring",
    title: "SIEM & Endpoint Monitoring",
    icon: "📡",
    description:
      "Platforms and telemetry used to collect, investigate, and visualize security events.",
    skills: [
      {
        name: "Wazuh",
        level: "operational",
        description: "Manager deployment, agent onboarding, and alert review"
      },
      {
        name: "Splunk Enterprise",
        level: "hands-on",
        description: "Log ingestion, searches, alerts, and dashboards"
      },
      {
        name: "Windows Event Logs",
        level: "operational",
        description: "Authentication and security-event analysis"
      },
      {
        name: "Sysmon",
        level: "operational",
        description: "Windows process and endpoint telemetry"
      },
      {
        name: "Linux Authentication Logs",
        level: "operational",
        description: "SSH, PAM, and authentication-event analysis"
      }
    ]
  },
  {
    id: "networking-infrastructure",
    title: "Networking & Infrastructure",
    icon: "🌐",
    description:
      "Enterprise networking concepts and practical infrastructure implementation.",
    skills: [
      {
        name: "VLAN Design",
        level: "operational",
        description: "Network segmentation and VLAN-based architecture"
      },
      {
        name: "Routing & Subnetting",
        level: "operational",
        description: "IP addressing, gateways, and inter-VLAN routing"
      },
      {
        name: "OPNsense",
        level: "operational",
        description: "Firewalling, NAT, interfaces, and network gateways"
      },
      {
        name: "Proxmox VE",
        level: "operational",
        description: "Virtual machines, Linux bridges, and lab infrastructure"
      },
      {
        name: "CCNA Networking Concepts",
        level: "hands-on",
        description: "Switching, routing, troubleshooting, and network fundamentals"
      }
    ]
  },
  {
    id: "systems-identity",
    title: "Systems & Identity",
    icon: "💻",
    description:
      "Windows, Linux, centralized identity, and endpoint administration.",
    skills: [
      {
        name: "Windows Server",
        level: "hands-on",
        description: "Server administration and domain services"
      },
      {
        name: "Active Directory",
        level: "operational",
        description: "Users, OUs, groups, domain joining, and access management"
      },
      {
        name: "Windows 10/11",
        level: "operational",
        description: "Endpoint administration and troubleshooting"
      },
      {
        name: "Linux Administration",
        level: "operational",
        description: "Ubuntu, Debian, Parrot OS, services, and permissions"
      },
      {
        name: "DNS & Authentication",
        level: "hands-on",
        description: "Name resolution, domain access, and login troubleshooting"
      }
    ]
  },
  {
    id: "enterprise-applications",
    title: "Enterprise Applications",
    icon: "🏢",
    description:
      "Business-system administration, testing, hosting, and user support.",
    skills: [
      {
        name: "Odoo Administration",
        level: "operational",
        description: "Multi-company users, access rights, testing, and support"
      },
      {
        name: "Odoo 18 & 19",
        level: "hands-on",
        description: "Production administration and upgrade testing"
      },
      {
        name: "Odoo Hosting",
        level: "hands-on",
        description: "Community and Enterprise environments on Linux"
      },
      {
        name: "PostgreSQL",
        level: "developing",
        description: "Database fundamentals for Odoo environments"
      },
      {
        name: "Business-System Support",
        level: "operational",
        description: "Troubleshooting workflows, users, and configuration issues"
      }
    ]
  },
  {
    id: "analysis-security-tools",
    title: "Analysis & Security Tools",
    icon: "🔍",
    description:
      "Tools used for traffic analysis, validation, scanning, and investigation.",
    skills: [
      {
        name: "Wireshark",
        level: "hands-on",
        description: "Packet inspection and PCAP analysis"
      },
      {
        name: "tcpdump",
        level: "hands-on",
        description: "Command-line packet capture and troubleshooting"
      },
      {
        name: "Nmap",
        level: "operational",
        description: "Network discovery and service enumeration"
      },
      {
        name: "VirusTotal",
        level: "operational",
        description: "Indicator and file-reputation validation"
      },
      {
        name: "ANY.RUN",
        level: "hands-on",
        description: "Interactive malware and phishing analysis"
      }
    ]
  },
  {
    id: "automation-development",
    title: "Automation & Development",
    icon: "⚙️",
    description:
      "Scripting and development skills supporting security and IT operations.",
    skills: [
      {
        name: "Python",
        level: "hands-on",
        description: "Security automation, parsing, and application development"
      },
      {
        name: "PowerShell",
        level: "developing",
        description: "Windows administration and automation"
      },
      {
        name: "Bash",
        level: "hands-on",
        description: "Linux administration and task automation"
      },
      {
        name: "JavaScript & React",
        level: "hands-on",
        description: "Frontend applications and portfolio development"
      },
      {
        name: "Git & GitHub",
        level: "operational",
        description: "Version control, project documentation, and publishing"
      }
    ]
  }
];

export default skillCategories;